import classNames from 'classnames';
import React__default from 'react';
import { getPrefixCls } from '../../../utils/getPrefix.js';

var prefixCls = getPrefixCls('skeleton');
function Text(_ref) {
  var width = _ref.width,
    className = _ref.className,
    _ref$dataTestid = _ref.dataTestid,
    dataTestid = _ref$dataTestid === void 0 ? 'skeletonText' : _ref$dataTestid;
  return /*#__PURE__*/React__default.createElement("span", {
    "sl-test-data": dataTestid,
    className: classNames("".concat(prefixCls), "".concat(prefixCls, "-text"), className),
    style: {
      width: "".concat(width, "px")
    }
  });
}

export { Text };
